import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import "@/styles/landing.css";

const Arrow = () => (
    <span className="arrow"><span className="ln-a" /><span className="sh" /></span>
);

export default function Landing() {
    const { user, settings } = useAuth();
    const goApp = user && user !== false;
    const testHref = goApp ? "/app/analisis/nuevo" : "/test";
    const contact = settings?.contact_email;

    useEffect(() => {
        const nav = document.getElementById("criteri-nav");
        const onScroll = () => nav && nav.classList.toggle("scrolled", window.scrollY > 10);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div className="criteri-landing">
            {/* navegación */}
            <header className="nav" id="criteri-nav">
                <div className="wrap">
                    <Link to="/" className="logo" data-testid="brand-logo"><i />MYAVEREN</Link>
                    <nav>
                        <a href="#como" className="ul">Cómo funciona</a>
                        <a href="#espejo" className="ul">La Tabla Espejo</a>
                        <a href="#precios" className="ul">Precios</a>
                        <a href="#faq" className="ul">FAQ</a>
                    </nav>
                    <div className="act">
                        {goApp ? (
                            <Link to="/app" className="btn btn-oro" data-testid="nav-go-app">Ir a mi cuenta <Arrow /></Link>
                        ) : (
                            <>
                                <Link to="/acceder" className="ul" data-testid="nav-login">Entrar</Link>
                                <Link to="/crear-cuenta" className="btn btn-oro" data-testid="nav-register">Empezar gratis <Arrow /></Link>
                            </>
                        )}
                    </div>
                </div>
            </header>

            <main>
                {/* hero */}
                <section className="wrap hero">
                    <div>
                        <p className="eyebrow" data-fade>Asesoría cosmética independiente</p>
                        <h1 data-fade>Menos botes. <span className="oro">Más criterio.</span></h1>
                        <p className="sub" data-fade>
                            Cuéntanos cómo es tu piel y qué tienes en el baño. Te decimos qué conservar,
                            qué no deberías usar junto y qué te falta de verdad.
                        </p>
                        <div className="ctas" data-fade>
                            <Link to={testHref} className="btn btn-oro" data-testid="hero-cta">
                                {goApp ? "Ir a mi análisis" : "Haz tu test de piel gratis"} <Arrow />
                            </Link>
                            <a href="#espejo" className="btn btn-linea" data-testid="hero-example">Ver un informe de ejemplo</a>
                        </div>
                        <div className="micro" data-fade>
                            <span>Gratis</span><span>Sin tarjeta</span><span>Test breve · 3 minutos</span>
                        </div>
                    </div>
                    <div className="hero-art">
                        <div className="frame hero-main">
                            <img src="https://images.unsplash.com/photo-1551184451-76b762941ad6?w=1400&q=80&auto=format&fit=crop" alt="Retrato de mujer con luz cálida sobre el rostro" />
                        </div>
                        <div className="frame hero-inset">
                            <img src="https://images.unsplash.com/photo-1576426863848-c21f53c60b19?w=700&q=80&auto=format&fit=crop" alt="Frasco cuentagotas blanco con anilla dorada" />
                        </div>
                        <div className="hero-note" data-fade>
                            <p className="eyebrow">Conflicto detectado</p>
                            <b>Retinol + ácido glicólico</b>
                            La misma noche. Altérnalos para no irritar la barrera.
                        </div>
                    </div>
                </section>

                {/* marquee */}
                <div className="marquee" aria-label="Activos que analizamos">
                    <div className="track">
                        {[0, 1].flatMap((r) =>
                            ["Niacinamida 5%", "Retinol 0,3%", "Ácido hialurónico", "Vitamina C 15%", "Ceramidas NP", "SPF 50 · PA++++", "Ácido salicílico 2%", "Péptidos", "Bakuchiol"].map((t) => (
                                <span key={t + r}>{t}</span>
                            ))
                        )}
                    </div>
                </div>

                {/* confianza */}
                <section className="trust">
                    <div className="wrap">
                        <div data-fade><b>Independiente</b>No vendemos productos ni cobramos de marcas.</div>
                        <div data-fade><b>Con base cosmética</b>Activos, concentraciones, pH y compatibilidades.</div>
                        <div data-fade><b>Tus datos, tuyos</b>Cifrados y solo tuyos. Bórralos cuando quieras.</div>
                        <div data-fade><b>Para llevar</b>Informe en PDF para tu farmacia o tu dermatóloga.</div>
                    </div>
                </section>

                {/* ¿te suena? */}
                <section className="sec hueso">
                    <div className="wrap suena">
                        <div className="frame">
                            <img src="https://images.unsplash.com/photo-1573461160327-b450ce3d8e7f?w=1200&q=80&auto=format&fit=crop" alt="Gotero aplicando sérum dorado sobre la piel" loading="lazy" />
                        </div>
                        <div>
                            <p className="eyebrow" data-fade>¿Te suena?</p>
                            <h2 className="h2" style={{ marginTop: 22 }}>Para quien está cansada de <span className="oro">probar y tirar</span></h2>
                            <ul>
                                <li data-fade><span>i.</span>Un sérum de vitamina C a medias desde marzo.</li>
                                <li data-fade><span>ii.</span>Dos cremas que quizá se están anulando en tu cara.</li>
                                <li data-fade><span>iii.</span>Un protector solar que no usas porque te deja brillos.</li>
                            </ul>
                            <p className="close" data-fade>No hace falta comprar más. Hace falta saber qué funciona para tu piel, en qué orden, con qué frecuencia y con qué no mezclarlo.</p>
                        </div>
                    </div>
                </section>

                {/* manifiesto */}
                <section className="sec manifesto">
                    <div className="wrap">
                        <p className="eyebrow" data-fade>Nuestra forma de trabajar</p>
                        <p className="big">No vendemos productos. Te ayudamos a usar mejor los que ya tienes <span className="oro">y a comprar solo lo justo.</span></p>
                    </div>
                </section>

                {/* cómo funciona */}
                <section className="sec" id="como" style={{ paddingTop: 0 }}>
                    <div className="wrap">
                        <div className="pasos-top">
                            <div>
                                <p className="eyebrow" data-fade>Cómo funciona</p>
                                <h2 className="h2" style={{ marginTop: 22 }}>Tres pasos, <span className="oro">una rutina clara</span></h2>
                            </div>
                            <p className="lead" data-fade>Utilizamos el Método NEROVA: primero TÚ, lo que te preocupa y lo que tu piel te está contando. Después, lo que ya tienes. Y por último, una rutina clara hecha para ti.</p>
                        </div>
                        <div className="pasos">
                            <div className="frame" style={{ aspectRatio: "3 / 4" }}>
                                <img src="https://images.unsplash.com/photo-1747303969063-3b90bcb3942e?w=900&q=80&auto=format&fit=crop" alt="Sérum cayendo de un gotero sobre un frasco ámbar" loading="lazy" />
                            </div>
                            <div className="paso" data-fade><div className="num">1</div><h3>Escuchamos tu piel</h3><p>Respondes unas preguntas sencillas sobre tu piel y tus hábitos. Con eso empezamos a entender qué necesita hoy.</p><div className="tm">≈ 3 min</div></div>
                            <div className="paso" data-fade><div className="num">2</div><h3>Revisamos lo que ya tienes</h3><p>Añade tus productos por nombre o con una foto del envase. Leemos su INCI por ti.</p><div className="tm">≈ 30 s por producto</div></div>
                            <div className="paso" data-fade><div className="num">3</div><h3>Recibes tu rutina</h3><p>Qué usar, cuándo y en qué orden. Y solo lo que te falta, en tres presupuestos.</p><div className="tm">Informe web + PDF</div></div>
                        </div>
                    </div>
                </section>

                {/* tabla espejo */}
                <section className="sec hueso" id="espejo">
                    <div className="wrap espejo">
                        <div>
                            <p className="eyebrow" data-fade>La Tabla Espejo</p>
                            <h2 className="h2" style={{ marginTop: 22 }}>Tu neceser, <span className="oro">frente a tu piel</span></h2>
                            <p className="lead" style={{ marginTop: 24 }} data-fade>Cruzamos cada producto con lo que tu piel necesita. Verás de un vistazo qué conservar, qué cambiar de momento del día y qué te sobra.</p>
                            <div className="legend" data-fade>
                                <div><span className="chip c-ok"><span className="d" />Conservar</span>Le sienta bien a tu piel.</div>
                                <div><span className="chip c-av"><span className="d" />Ajustar</span>Bueno, pero mal usado o a destiempo.</div>
                                <div><span className="chip c-al"><span className="d" />Sobra</span>Repetido, inadecuado o irritante.</div>
                            </div>
                        </div>
                        <div className="report-stage">
                            <div className="bg"><img src="https://images.unsplash.com/photo-1748543668687-624e058c367c?w=1400&q=80&auto=format&fit=crop" alt="" loading="lazy" /></div>
                            <div className="report" data-fade>
                                <div className="report-h"><b>Informe de ejemplo</b><span className="chip c-neu">Piel mixta · deshidratada</span></div>
                                <div className="tbl">
                                    <table>
                                        <thead><tr><th>Producto</th><th>Función</th><th>Veredicto</th></tr></thead>
                                        <tbody>
                                            <tr><td>Sérum vitamina C<small>Ácido ascórbico 15% · pH 3,2</small></td><td>Antioxidante</td><td><span className="chip c-av"><span className="d" />Pásalo a la mañana</span></td></tr>
                                            <tr><td>Hidratante con ceramidas<small>Ceramidas NP, AP · glicerina</small></td><td>Barrera</td><td><span className="chip c-ok"><span className="d" />Conservar</span></td></tr>
                                            <tr><td>Exfoliante AHA<small>Ácido glicólico 7%</small></td><td>Renovación</td><td><span className="chip c-av"><span className="d" />2 noches por semana</span></td></tr>
                                            <tr><td>Crema de noche rica<small>Manteca de karité · aceite mineral</small></td><td>Nutrición</td><td><span className="chip c-al"><span className="d" />Sobra en zona T</span></td></tr>
                                            <tr><td>Fluido solar<small>SPF 50 · PA++++ · oil-free</small></td><td>Fotoprotección</td><td><span className="chip c-ok"><span className="d" />Conservar</span></td></tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="conflict"><span className="chip c-al">Conflicto</span><div><b>Retinol 0,3% + ácido glicólico 7%</b> en la misma noche. Alterna: retinol lunes, miércoles y viernes; exfoliante martes y sábado.</div></div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* por qué CRÍTERI */}
                <section className="sec">
                    <div className="wrap">
                        <div className="ventajas-head">
                            <div>
                                <p className="eyebrow" data-fade>Por qué MYAVEREN</p>
                                <h2 className="h2" style={{ marginTop: 22 }}>Criterio, <span className="oro">sin tecnicismos</span></h2>
                            </div>
                            <p className="lead" data-fade>Lo que haría una amiga que sabe de cosmética, con el rigor de quien lee cada etiqueta.</p>
                        </div>
                        <div className="ventajas">
                            <div className="ventaja" data-fade><span className="k">TONO</span><h3>Como una amiga que sabe</h3><p>Te lo explicamos sin jerga. Y si quieres el INCI, también está.</p></div>
                            <div className="ventaja" data-fade><span className="k">CADA 42 DÍAS</span><h3>A tu ritmo</h3><p>Repite el análisis al ritmo de renovación de tu piel y mira cómo cambia.</p></div>
                            <div className="ventaja" data-fade><span className="k">ACTIVOS</span><h3>Compatible de verdad</h3><p>Detectamos combinaciones que irritan antes de que lo note tu piel.</p></div>
                            <div className="ventaja" data-fade><span className="k">LOW · OPTIMUM · PREMIUM</span><h3>Tres presupuestos</h3><p>Si te falta algo, te damos una opción económica, una media y una premium.</p></div>
                        </div>
                    </div>
                </section>

                {/* precios */}
                <section className="sec hueso" id="precios">
                    <div className="wrap">
                        <div className="center">
                            <p className="eyebrow" data-fade>Precios</p>
                            <h2 className="h2" style={{ marginTop: 22 }}>Empieza gratis. <span className="oro">Sigue si te sirve.</span></h2>
                            <p className="lead" data-fade>Sin permanencia. Cancelas desde tu cuenta en dos clics.</p>
                        </div>
                        <div className="precios">
                            <div className="plan" data-fade>
                                <p className="eyebrow">Opción 1 · Esencial</p><h3>Esencial</h3><div className="pr">0 €</div><p>Para conocer tu piel y probar el método.</p>
                                <ul><li>Hasta 3 análisis</li><li>Hasta 6 productos en tu neceser</li><li>Lectura básica de lo que ya tienes</li><li>Cobertura básica de tu rutina</li><li>1 informe en PDF</li></ul>
                                <Link to={testHref} className="btn btn-linea" data-testid="pricing-free-cta">Seguir con Esencial</Link>
                            </div>
                            <div className="plan dest" data-fade>
                                <p className="eyebrow" style={{ color: "var(--oro-txt)" }}>Opción 2 · Completo</p><h3>Completo</h3><div className="pr">19,90 € <small>· pago único</small></div><p>Tu análisis completo y tu rutina, de una vez.</p>
                                <ul>
                                    <li>Análisis producto a producto</li>
                                    <li>Te indicamos qué mantener, ajustar, revisar o dejar</li>
                                    <li>Analizamos tu punto de partida, trazamos un plan de transición y definimos tu objetivo de cuidado</li>
                                    <li>Construimos tu rutina de mañana y de noche, con orden, frecuencia y alternancias</li>
                                    <li>Detectamos carencias reales y solo recomendamos algo si de verdad hace falta</li>
                                    <li>Y recibes un informe completo en pantalla y también un PDF detallado</li>
                                </ul>
                                <Link to={testHref} className="btn btn-oro" data-testid="pricing-paid-cta">Desbloquear mi análisis completo <Arrow /></Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* testimonio */}
                <section className="sec">
                    <div className="wrap testi">
                        <div className="frame">
                            <img src="https://images.unsplash.com/photo-1695990190064-e8ca2ca16af6?w=1100&q=80&auto=format&fit=crop" alt="Mujer con pecas y piel natural apoyando la cara en las manos" loading="lazy" />
                        </div>
                        <div>
                            <p className="eyebrow" data-fade>Historias reales</p>
                            <blockquote data-fade style={{ marginTop: 24 }}>Aquí irá el testimonio de una clienta real: qué tenía en su neceser, qué cambió y en cuánto tiempo lo notó.</blockquote>
                            <span className="ph" data-fade>Espacio reservado · nombre, edad y tipo de piel con permiso por escrito</span>
                        </div>
                    </div>
                </section>

                {/* faq */}
                <section className="sec hueso" id="faq">
                    <div className="wrap">
                        <div className="center">
                            <p className="eyebrow" data-fade>Preguntas frecuentes</p>
                            <h2 className="h2" style={{ marginTop: 22 }}>Antes de <span className="oro">empezar</span></h2>
                        </div>
                        <div className="faq">
                            <details open><summary>¿Sois dermatólogos?</summary><p>No. MYAVEREN es asesoría cosmética, no diagnóstico médico. Si en tu test aparecen señales de rosácea, dermatitis o acné moderado o severo, te recomendaremos ir a consulta antes de cambiar nada.</p></details>
                            <details><summary>¿Qué pasa con mis fotos?</summary><p>La foto del envase es opcional: solo la usamos para identificar el producto en ese momento y leer su INCI. No la publicamos ni la cedemos, y tus datos los puedes borrar cuando quieras desde Ajustes.</p></details>
                            <details><summary>¿Me vais a vender productos?</summary><p>No vendemos productos. Si te falta algo, te proponemos tres opciones de precio. Si algún enlace es de afiliación, lo indicamos siempre.</p></details>
                            <details><summary>¿Cada cuánto debo repetir el análisis?</summary><p>Cada 42 días aproximadamente, lo que tarda la piel en renovarse. Así ves si la rutina funciona y la ajustamos con datos.</p></details>
                        </div>
                    </div>
                </section>

                {/* cierre */}
                <section className="final">
                    <div className="txt">
                        <p className="eyebrow" data-fade>Tu piel te está diciendo algo</p>
                        <h2 className="h2">Vamos a <span className="oro">escucharla.</span></h2>
                        <p className="lead" data-fade>Haz el test en tres minutos y descubre qué hay en tu neceser que te sobra.</p>
                        <div data-fade>
                            <Link to={testHref} className="btn btn-oro" data-testid="footer-cta">
                                {goApp ? "Ir a mi cuenta" : "Haz tu test de piel gratis"} <Arrow />
                            </Link>
                        </div>
                    </div>
                    <div className="frame">
                        <img src="https://images.unsplash.com/photo-1577746838851-816a43ca8733?w=1400&q=80&auto=format&fit=crop" alt="Mujer de perfil con luz suave sobre fondo claro" loading="lazy" />
                    </div>
                </section>

                {/* footer */}
                <footer className="foot">
                    <div className="wrap">
                        <div className="cols">
                            <div>
                                <Link to="/" className="logo" style={{ fontSize: 20 }}><i />MYAVEREN</Link>
                                <p className="brand-note">Asesoría cosmética independiente. Analizamos tu piel, revisamos tu neceser y te decimos qué conservar, qué no mezclar y qué te falta de verdad.</p>
                            </div>
                            <div>
                                <h4>Producto</h4>
                                <ul>
                                    <li><a href="#como" className="ul">Cómo funciona</a></li>
                                    <li><a href="#espejo" className="ul">La Tabla Espejo</a></li>
                                    <li><a href="#precios" className="ul">Precios</a></li>
                                </ul>
                            </div>
                            <div>
                                <h4>Cuenta</h4>
                                <ul>
                                    <li><Link to="/acceder" className="ul">Entrar</Link></li>
                                    <li><Link to="/crear-cuenta" className="ul">Empezar gratis</Link></li>
                                </ul>
                            </div>
                            <div>
                                <h4>Legal</h4>
                                <ul>
                                    <li><Link to="/privacidad" className="ul" data-testid="footer-privacy-link">Privacidad y datos</Link></li>
                                    <li><Link to="/legal" className="ul" data-testid="footer-legal-link">Aviso legal y condiciones</Link></li>
                                    <li>{contact ? <a href={`mailto:${contact}`} className="ul">{contact}</a> : <span>Contacto próximamente</span>}</li>
                                </ul>
                            </div>
                        </div>
                        <div className="wordmark"><span><span className="dot" aria-hidden="true"></span>MYAVEREN</span></div>
                        <div className="legal">
                            <span>© {new Date().getFullYear()} MYAVEREN · Asesoría cosmética, no diagnóstico médico.</span>
                            <span>Hecho con criterio en España.</span>
                        </div>
                    </div>
                </footer>
            </main>
        </div>
    );
}
